import { render, staticRenderFns } from "./ev5-single-video.vue?vue&type=template&id=6dfe6aaa&scoped=true&"
import script from "./ev5-single-video.vue?vue&type=script&lang=js&"
export * from "./ev5-single-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfe6aaa",
  null
  
)

export default component.exports